import React, { useContext, useMemo, useEffect } from "react";
import {
  FormControl,
  InputLabel,
} from "@mui/material";
import { useFormik } from "formik";
import { ContextSheet } from "../../Context/SheetContext";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';


export default function AutocompleteField() {

  const valueSheet = useContext(ContextSheet);

  const initValues = {

    ...valueSheet.userSelected,
    assignTo: useMemo(() => valueSheet.userFullName.filter((person) =>
      valueSheet.userSelected.some((obj) => obj.id === person.id), [valueSheet]))
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initValues,
    onSubmit: (values) => {
      console.log("values submit ", values.assignTo);
    }

  });

  useEffect(() => {

    const usersInfo = async () => {

      let arry = [];
      let fullInfo = [];



      await formik.values.assignTo.map((item) => {
        // console.log('usersInfo', item.id);
        arry.push(item.id);
        fullInfo.push(item);
      })


      // valueSheet.setUsersUid([...arry]);
      valueSheet.setUsersUid(arry);

      valueSheet.setAssignUsers([...fullInfo]);


      const Filtered = valueSheet.userSelected.filter(x => !formik.values.assignTo.some(i => i.id === x.id));

      valueSheet.setRemoveUsers(Filtered);



    }


    usersInfo();


  }, [formik.values.assignTo])


  return (
    <div>
      <InputLabel id="demo-simple-select-standard-label">Assign Users :</InputLabel>
      <FormControl sx={{ m: 1, width: 300 }} size="small">
        <Autocomplete
          multiple
          limitTags={1}
          size='small'
          id="multiple-limit-tags"
          options={valueSheet.userFullName}
          getOptionLabel={(option) => option.FullName}
          onChange={(e, obj) => { formik.setFieldValue('assignTo', obj); }}
          value={formik.values.assignTo}
          // onChange={(e) => {
          //   // console.log("set ", e.target.value);
          //   formik.setFieldValue("assignTo", e.target.value);
          // }}
          // defaultValue={[formik.values.assignTo]}

          renderInput={(params) => (
            <TextField {...params} label="Users List" placeholder="Users" />
          )}
          sx={{ width: '300px' }}
        />


      </FormControl>
    </div>
  );
}
